<script setup>
import Default from '@/Layouts/Default.vue';
import Content from '@/Components/Content/index.vue';
import AccordianGroup from '@/Components/Accordion/Group.vue';
import AccordianItem from '@/Components/Accordion/Item.vue';
import Heading from '@/Components/Heading.vue';
import ScholarshipHeader from '@/Components/Content/Header/Scholarship.vue';
import { computed } from 'vue';
import { Head, usePage } from '@inertiajs/vue3';
const props = defineProps({
  scholarship: {
    type: Object,
    required: true,
  }
});

const auDollarFormatter = (dollars) => `AUD $${Intl.NumberFormat().format(dollars)}`;

const levelsOfStudy = computed(() => {
  if(!props.scholarship.level_of_studies.length) {
    return null;
  }
  return props.scholarship.level_of_studies.map((los) => {
    return los.name;
  })
  .join(', ');
});

const page = usePage();
const context = computed(() => page.props?.context);
const providerName = context.value.name;
</script>


<template>
  <Head>
    <title>{{props.scholarship.name}} - {{ providerName }}</title>
    <meta name="description" :content="props.scholarship.description">
  </Head>
  <Default>
    <Content>
      <template #header>
        <ScholarshipHeader :scholarship="scholarship"/>
      </template>
      <template #content>
        <Heading
          size="h2"
          style-size="h2"
          class="mb-2"
        >
          Scholarship Information
        </Heading>
        <p
          v-if="scholarship.amount_annual"
          class="mb-2"
        >
          <strong>Award value:</strong> {{ auDollarFormatter(scholarship.amount_annual) }} annually
        </p>
        <p
          v-if="levelsOfStudy"
          class="mb-2"
        >
          <strong>Level of study:</strong> {{ levelsOfStudy }}
        </p>
        <p
          v-if="scholarship.student_type"
          class="mb-2"
        >
          <strong>Nationality:</strong> {{ scholarship.student_type }}
        </p>
        <p
          v-if="scholarship.closing_date"
          class="mb-2"
        >
          <strong>Closing date:</strong> {{ scholarship.closing_date }}
        </p>
        <p class="mb-2">
          {{ scholarship.description }}
        </p>
        <AccordianGroup>
          <AccordianItem>
            <template #title>
              Eligibility Requirements
            </template>
            <template #content>
              <p>{{ scholarship.eligibility }}</p>
            </template>
          </AccordianItem>
        </AccordianGroup>
      </template>
    </Content>
  </Default>
</template>
